import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";
var SEMESTERS_ENDPOINT = "".concat(constants.API_URL, "/semesters");

var getStudentCertificate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var semesterId, studentId, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            semesterId = _ref.semesterId, studentId = _ref.studentId;
            _context.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/students/").concat(studentId, "/gradebook/certificate"));

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getStudentCertificate(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var getStudentGrades = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var semesterId, studentId, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            semesterId = _ref3.semesterId, studentId = _ref3.studentId;
            _context2.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/students/").concat(studentId, "/gradebook/summary"));

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getStudentGrades(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var getSemesterCourses = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var semesterId, userId, params, _yield$http$get, data, count;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            semesterId = _ref5.semesterId, userId = _ref5.userId, params = _ref5.params;
            _context3.next = 3;
            return http.get("".concat(constants.API_URL_V1, "/semesters/").concat(semesterId, "/users/").concat(userId, "/courses"), {
              params: params
            });

          case 3:
            _yield$http$get = _context3.sent;
            data = _yield$http$get.data;
            count = _yield$http$get.count;
            return _context3.abrupt("return", {
              data: data,
              count: count
            });

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getSemesterCourses(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

var getSemesterMasteryLevels = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var semesterId, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            semesterId = _ref7.semesterId;
            _context4.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/mastery-levels"));

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getSemesterMasteryLevels(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

var getSkillCategories = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
    var semesterId, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            semesterId = _ref9.semesterId;
            _context5.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/skill-categories"));

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getSkillCategories(_x5) {
    return _ref10.apply(this, arguments);
  };
}();

var createSkillCategory = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref11) {
    var semesterId, data, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            semesterId = _ref11.semesterId, data = _ref11.data;
            _context6.next = 3;
            return http.post("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/skill-categories"), data);

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function createSkillCategory(_x6) {
    return _ref12.apply(this, arguments);
  };
}();

var createSkillEntry = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref13) {
    var semesterId, data, response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            semesterId = _ref13.semesterId, data = _ref13.data;
            _context7.next = 3;
            return http.post("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/skills"), data);

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function createSkillEntry(_x7) {
    return _ref14.apply(this, arguments);
  };
}();

var getSkills = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref15) {
    var semesterId, response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            semesterId = _ref15.semesterId;
            _context8.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/skills"));

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getSkills(_x8) {
    return _ref16.apply(this, arguments);
  };
}();

var copySkillsSemesterSettings = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref17) {
    var sourceSemesterId, data, response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            sourceSemesterId = _ref17.sourceSemesterId, data = _ref17.data;
            _context9.next = 3;
            return http.post("".concat(constants.API_URL, "/semesters/").concat(sourceSemesterId, "/skill-grading-settings/copy"), data);

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function copySkillsSemesterSettings(_x9) {
    return _ref18.apply(this, arguments);
  };
}();

function copySemesterSettings(_x10) {
  return _copySemesterSettings.apply(this, arguments);
}

function _copySemesterSettings() {
  _copySemesterSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(_ref19) {
    var semesterId, params, response;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            semesterId = _ref19.semesterId, params = _ref19.params;
            _context29.next = 3;
            return http.post("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/gradebook/copy"), params);

          case 3:
            response = _context29.sent;
            return _context29.abrupt("return", response);

          case 5:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));
  return _copySemesterSettings.apply(this, arguments);
}

var getCourseTemplateSkillsSetup = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref20) {
    var semesterId, courseTemplateId, response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            semesterId = _ref20.semesterId, courseTemplateId = _ref20.courseTemplateId;
            _context10.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/course-templates/").concat(courseTemplateId, "/skills-setup"));

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function getCourseTemplateSkillsSetup(_x11) {
    return _ref21.apply(this, arguments);
  };
}();

var getSkillCategory = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref22) {
    var skillCategoryId, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            skillCategoryId = _ref22.skillCategoryId;
            _context11.next = 3;
            return http.get("".concat(constants.API_URL, "/skill-categories/").concat(skillCategoryId));

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response);

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function getSkillCategory(_x12) {
    return _ref23.apply(this, arguments);
  };
}();

var deleteSkillCategory = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref24) {
    var skillCategoryId, response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            skillCategoryId = _ref24.skillCategoryId;
            _context12.next = 3;
            return http["delete"]("".concat(constants.API_URL, "/skill-categories/").concat(skillCategoryId));

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response);

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function deleteSkillCategory(_x13) {
    return _ref25.apply(this, arguments);
  };
}();

var editSkillCategory = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref26) {
    var skillCategoryId, data, response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            skillCategoryId = _ref26.skillCategoryId, data = _ref26.data;
            _context13.next = 3;
            return http.patch("".concat(constants.API_URL, "/skill-categories/").concat(skillCategoryId), data);

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response);

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function editSkillCategory(_x14) {
    return _ref27.apply(this, arguments);
  };
}();

var getSemesterGradeDefaultViews = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref28) {
    var semesterId, response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            semesterId = _ref28.semesterId;
            _context14.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/grade-default-views"));

          case 3:
            response = _context14.sent;
            return _context14.abrupt("return", response);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function getSemesterGradeDefaultViews(_x15) {
    return _ref29.apply(this, arguments);
  };
}();

var editStageGradeDefaultView = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref30) {
    var defaultViewId, data, response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            defaultViewId = _ref30.defaultViewId, data = _ref30.data;
            _context15.next = 3;
            return http.patch("".concat(constants.API_URL, "/grade-default-views/").concat(defaultViewId), data);

          case 3:
            response = _context15.sent;
            return _context15.abrupt("return", response);

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function editStageGradeDefaultView(_x16) {
    return _ref31.apply(this, arguments);
  };
}();

var updateHiddenGradebook = /*#__PURE__*/function () {
  var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref32) {
    var stageId, semesterId, data, response;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            stageId = _ref32.stageId, semesterId = _ref32.semesterId, data = _ref32.data;
            _context16.next = 3;
            return http.patch("".concat(constants.API_URL, "/stages/").concat(stageId, "/semesters/").concat(semesterId, "/gradebook/hidden-for"), data);

          case 3:
            response = _context16.sent;
            return _context16.abrupt("return", response);

          case 5:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function updateHiddenGradebook(_x17) {
    return _ref33.apply(this, arguments);
  };
}();

var semesterUrl = function semesterUrl(id) {
  return "".concat(SEMESTERS_ENDPOINT, "/").concat(id);
};

var updateSemester = /*#__PURE__*/function () {
  var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(semesterId, updates) {
    var response;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return http.patch("".concat(semesterUrl(semesterId)), updates);

          case 2:
            response = _context17.sent;
            return _context17.abrupt("return", response);

          case 4:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function updateSemester(_x18, _x19) {
    return _ref34.apply(this, arguments);
  };
}();

var activateSemester = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(semesterId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return http.post("".concat(semesterUrl(semesterId), "/activate"));

          case 2:
            response = _context18.sent;
            return _context18.abrupt("return", response);

          case 4:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function activateSemester(_x20) {
    return _ref35.apply(this, arguments);
  };
}();

var lockSemester = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(semesterId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return http.post("".concat(semesterUrl(semesterId), "/lock"));

          case 2:
            response = _context19.sent;
            return _context19.abrupt("return", response);

          case 4:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function lockSemester(_x21) {
    return _ref36.apply(this, arguments);
  };
}();

var archiveSemester = /*#__PURE__*/function () {
  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(semesterId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return http.post("".concat(semesterUrl(semesterId), "/archive"));

          case 2:
            response = _context20.sent;
            return _context20.abrupt("return", response);

          case 4:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));

  return function archiveSemester(_x22) {
    return _ref37.apply(this, arguments);
  };
}();

var copySemesterCourses = /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref38) {
    var semesterId, data, response;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            semesterId = _ref38.semesterId, data = _ref38.data;
            _context21.next = 3;
            return http.post("".concat(semesterUrl(semesterId), "/courses/copy"), data);

          case 3:
            response = _context21.sent;
            return _context21.abrupt("return", response);

          case 5:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));

  return function copySemesterCourses(_x23) {
    return _ref39.apply(this, arguments);
  };
}();

function getStageGradebookDisplays(_x24) {
  return _getStageGradebookDisplays.apply(this, arguments);
}

function _getStageGradebookDisplays() {
  _getStageGradebookDisplays = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(semesterId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/stage-gradebook-displays"));

          case 2:
            response = _context30.sent;
            return _context30.abrupt("return", response);

          case 4:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30);
  }));
  return _getStageGradebookDisplays.apply(this, arguments);
}

function createStageGradebookDisplays(_x25, _x26) {
  return _createStageGradebookDisplays.apply(this, arguments);
}

function _createStageGradebookDisplays() {
  _createStageGradebookDisplays = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(semesterId, data) {
    var response;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            _context31.next = 2;
            return http.post("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/stage-gradebook-displays"), data);

          case 2:
            response = _context31.sent;
            return _context31.abrupt("return", response);

          case 4:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31);
  }));
  return _createStageGradebookDisplays.apply(this, arguments);
}

function getCourseGradebookPolicies(_x27) {
  return _getCourseGradebookPolicies.apply(this, arguments);
}

function _getCourseGradebookPolicies() {
  _getCourseGradebookPolicies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(semesterId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            _context32.next = 2;
            return http.get("".concat(semesterUrl(semesterId), "/course-gradebook-policies"));

          case 2:
            response = _context32.sent;
            return _context32.abrupt("return", response);

          case 4:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32);
  }));
  return _getCourseGradebookPolicies.apply(this, arguments);
}

function createCourseGradebookPolicies(_x28, _x29) {
  return _createCourseGradebookPolicies.apply(this, arguments);
}

function _createCourseGradebookPolicies() {
  _createCourseGradebookPolicies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(semesterId, data) {
    var response;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            _context33.next = 2;
            return http.post("".concat(semesterUrl(semesterId), "/course-gradebook-policies"), data);

          case 2:
            response = _context33.sent;
            return _context33.abrupt("return", response);

          case 4:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33);
  }));
  return _createCourseGradebookPolicies.apply(this, arguments);
}

var downloadAllSchedules = /*#__PURE__*/function () {
  var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_ref40) {
    var semesterId, params, onDownloadProgress, response;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            semesterId = _ref40.semesterId, params = _ref40.params, onDownloadProgress = _ref40.onDownloadProgress;
            _context22.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/class-schedules/download-all"), {
              params: params,
              responseType: "arraybuffer",
              onDownloadProgress: onDownloadProgress
            });

          case 3:
            response = _context22.sent;
            return _context22.abrupt("return", response);

          case 5:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));

  return function downloadAllSchedules(_x30) {
    return _ref41.apply(this, arguments);
  };
}();

var exportOverallGrades = /*#__PURE__*/function () {
  var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(_ref42) {
    var semesterId, params, onDownloadProgress, response;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            semesterId = _ref42.semesterId, params = _ref42.params, onDownloadProgress = _ref42.onDownloadProgress;
            _context23.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/gradebook/overall-grades/zip"), {
              params: params,
              responseType: "blob",
              onDownloadProgress: onDownloadProgress
            });

          case 3:
            response = _context23.sent;
            return _context23.abrupt("return", response);

          case 5:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));

  return function exportOverallGrades(_x31) {
    return _ref43.apply(this, arguments);
  };
}();

var exportDetailedGrades = /*#__PURE__*/function () {
  var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(_ref44) {
    var semesterId, params, onDownloadProgress, response;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            semesterId = _ref44.semesterId, params = _ref44.params, onDownloadProgress = _ref44.onDownloadProgress;
            _context24.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/gradebook/courses/detailed-grades/zip"), {
              params: params,
              responseType: "blob",
              onDownloadProgress: onDownloadProgress
            });

          case 3:
            response = _context24.sent;
            return _context24.abrupt("return", response);

          case 5:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));

  return function exportDetailedGrades(_x32) {
    return _ref45.apply(this, arguments);
  };
}();

var exportStagesOverallGradesByCourseTemplate = /*#__PURE__*/function () {
  var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(_ref46) {
    var semesterId, params, onDownloadProgress, response;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            semesterId = _ref46.semesterId, params = _ref46.params, onDownloadProgress = _ref46.onDownloadProgress;
            _context25.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/gradebook/course-templates/detailed-grades/zip"), {
              params: params,
              responseType: "blob",
              onDownloadProgress: onDownloadProgress
            });

          case 3:
            response = _context25.sent;
            return _context25.abrupt("return", response);

          case 5:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));

  return function exportStagesOverallGradesByCourseTemplate(_x33) {
    return _ref47.apply(this, arguments);
  };
}();

var getCourseTemplateAttendanceSettings = /*#__PURE__*/function () {
  var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(_ref48) {
    var semesterId, courseTemplateId, response;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            semesterId = _ref48.semesterId, courseTemplateId = _ref48.courseTemplateId;
            _context26.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/course-templates/").concat(courseTemplateId, "/course-template-attendance-settings"));

          case 3:
            response = _context26.sent;
            return _context26.abrupt("return", response);

          case 5:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));

  return function getCourseTemplateAttendanceSettings(_x34) {
    return _ref49.apply(this, arguments);
  };
}();

var exportAttendanceRecords = /*#__PURE__*/function () {
  var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(_ref50) {
    var semesterId, params, onDownloadProgress, response;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            semesterId = _ref50.semesterId, params = _ref50.params, onDownloadProgress = _ref50.onDownloadProgress;
            _context27.next = 3;
            return http.get("".concat(constants.API_URL, "/semesters/").concat(semesterId, "/attendance-records/zip"), {
              params: params,
              responseType: "blob",
              onDownloadProgress: onDownloadProgress
            });

          case 3:
            response = _context27.sent;
            return _context27.abrupt("return", response);

          case 5:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));

  return function exportAttendanceRecords(_x35) {
    return _ref51.apply(this, arguments);
  };
}();

var exportAttendanceRecordsV1 = /*#__PURE__*/function () {
  var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(_ref52) {
    var semesterId, params, onDownloadProgress, response;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            semesterId = _ref52.semesterId, params = _ref52.params, onDownloadProgress = _ref52.onDownloadProgress;
            _context28.next = 3;
            return http.get("".concat(constants.API_URL_V1, "/semesters/").concat(semesterId, "/attendance-records/zip"), {
              params: params,
              responseType: "blob",
              onDownloadProgress: onDownloadProgress
            });

          case 3:
            response = _context28.sent;
            return _context28.abrupt("return", response);

          case 5:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));

  return function exportAttendanceRecordsV1(_x36) {
    return _ref53.apply(this, arguments);
  };
}();

export default {
  getStudentCertificate: getStudentCertificate,
  getStudentGrades: getStudentGrades,
  getSemesterCourses: getSemesterCourses,
  getSemesterMasteryLevels: getSemesterMasteryLevels,
  getSkillCategories: getSkillCategories,
  createSkillCategory: createSkillCategory,
  deleteSkillCategory: deleteSkillCategory,
  editSkillCategory: editSkillCategory,
  getSkillCategory: getSkillCategory,
  createSkillEntry: createSkillEntry,
  getSkills: getSkills,
  getSemesterGradeDefaultViews: getSemesterGradeDefaultViews,
  editStageGradeDefaultView: editStageGradeDefaultView,
  copySkillsSemesterSettings: copySkillsSemesterSettings,
  copySemesterSettings: copySemesterSettings,
  getCourseTemplateSkillsSetup: getCourseTemplateSkillsSetup,
  updateHiddenGradebook: updateHiddenGradebook,
  updateSemester: updateSemester,
  activateSemester: activateSemester,
  lockSemester: lockSemester,
  archiveSemester: archiveSemester,
  copySemesterCourses: copySemesterCourses,
  getStageGradebookDisplays: getStageGradebookDisplays,
  createStageGradebookDisplays: createStageGradebookDisplays,
  getCourseGradebookPolicies: getCourseGradebookPolicies,
  createCourseGradebookPolicies: createCourseGradebookPolicies,
  downloadAllSchedules: downloadAllSchedules,
  exportOverallGrades: exportOverallGrades,
  exportDetailedGrades: exportDetailedGrades,
  exportStagesOverallGradesByCourseTemplate: exportStagesOverallGradesByCourseTemplate,
  getCourseTemplateAttendanceSettings: getCourseTemplateAttendanceSettings,
  exportAttendanceRecords: exportAttendanceRecords,
  exportAttendanceRecordsV1: exportAttendanceRecordsV1
};